import * as fs from 'node:fs';
import { forEachWithGitYield } from '../git/git-runtime.js';
import { gitWorktreeRemoveForce } from '../git/worktrees/worktree-remove.js';
import type { LogFn } from '../log.js';
import { isRemovableSessionWorktreeCheckoutPath } from './is-removable-session-worktree-checkout-path.js';

export async function removeSessionWorktrees(
  paths: string[],
  worktreesRootPath: string,
  log: LogFn,
): Promise<void> {
  await forEachWithGitYield(paths, async (wt) => {
    if (!isRemovableSessionWorktreeCheckoutPath(wt, worktreesRootPath)) {
      log(`[worktrees] Skipping removal of ${wt} (bridge root or outside worktrees root).`);
      return;
    }
    try {
      const removed = await gitWorktreeRemoveForce(wt);
      if (removed) {
        log(`[worktrees] Removed worktree ${wt}`);
      } else {
        log(`[worktrees] Skipping removal of ${wt} (bridge root).`);
      }
    } catch (e) {
      log(`[worktrees] Remove failed for ${wt}: ${e instanceof Error ? e.message : String(e)}`);
      if (isRemovableSessionWorktreeCheckoutPath(wt, worktreesRootPath)) {
        try {
          fs.rmSync(wt, { recursive: true, force: true });
        } catch {
          /* ignore */
        }
      }
    }
  });
}
